module.exports = __webpack_public_path__ + "assets/send-sms-link.2e49ef73.svg";